module.exports = __webpack_public_path__ + "img/ctrl-pauli-z-1.9d42e60b.svg";